import { Link } from 'react-router-dom';
import StatusPill from '../../../components/ui/StatusPill/StatusPill';
import './FeaturedProjectPreview.css';

export default function FeaturedProjectPreview({ project }) {
  if (!project) return null;
  const {
    slug,
    name,
    location,
    shortDescription,
    status,
    quickFacts = [],
    keyFeatures = [],
    hero,
    imageMode,
  } = project;

  const facts = quickFacts.filter((f) => f.label !== 'Location').slice(0, 3);
  const isFlyer = imageMode === 'flyer';

  return (
    <div className={`feat-preview${isFlyer ? ' feat-preview--flyer' : ''}`}>
      <div className="feat-preview__media">
        <picture>
          {hero.srcWebp && <source srcSet={hero.srcWebp} type="image/webp" />}
          <img
            src={hero.srcSmall || hero.src}
            alt={hero.alt}
            width={hero.width}
            height={hero.height}
            loading="lazy"
          />
        </picture>
      </div>

      <div className="feat-preview__body">
        <StatusPill status={status} />
        <h3 className="feat-preview__name">{name}</h3>
        <p className="feat-preview__loc">{location.display}</p>
        <p className="feat-preview__desc">{shortDescription}</p>

        {facts.length > 0 && (
          <div className="feat-preview__facts">
            {facts.map((f) => (
              <div key={f.label} className="feat-preview__fact">
                <span className="feat-preview__fact-value">{f.value}</span>
                <span className="feat-preview__fact-label">{f.label}</span>
              </div>
            ))}
          </div>
        )}

        {keyFeatures.length > 0 && (
          <p className="feat-preview__features">
            {keyFeatures.map((f, i) => (
              <span key={f}>
                {i > 0 && <span className="feat-preview__features-sep" aria-hidden="true"> · </span>}
                {f}
              </span>
            ))}
          </p>
        )}

        <div className="feat-preview__actions">
          <Link to={`/projects/${slug}`} className="btn btn--dark">
            View Project
          </Link>
          <Link to="/projects" className="btn btn--outline">
            View All Projects
          </Link>
        </div>
      </div>
    </div>
  );
}
